import React from 'react';
import PropTypes from 'prop-types';
import Day from 'components/Filters/Day';


const DayFilter = ({ selectedDate, onClick, dates, brandClass }) => (
  <div className="react-day-filter-container">
    <div className="react-day-filter-boxes-container">
      {dates && dates.map(date => (
        <Day
          key={date.date}
          id={date.dateId}
          title={date.day}
          date={date.date}
          selectedDate={selectedDate}
          onClick={(id) => { onClick(id); }}
          disabledDate={date.disabledDate}
          brandClass={brandClass}
        />
      ))}
    </div>
  </div>
);

DayFilter.propTypes = {
  brandClass: PropTypes.string.isRequired,
  selectedDate: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({}),
  ]).isRequired,
  onClick: PropTypes.func.isRequired,
  dates: PropTypes.arrayOf(PropTypes.shape({})),
};

DayFilter.defaultProps = {
  dates: null,
};

export default DayFilter;
